import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  id: "Djprogram"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_HomeListTitle = _resolveComponent("HomeListTitle");

  var _component_MusicList = _resolveComponent("MusicList");

  return _ctx.djprogramList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_HomeListTitle, {
    title: "主播电台"
  }), _createVNode(_component_MusicList, {
    musicList: _ctx.djprogramList,
    itemHeight: "88px"
  }, null, 8
  /* PROPS */
  , ["musicList"])])) : _createCommentVNode("v-if", true);
}